import * as React from 'react';
import { Tabs } from 'library/ui';
import { useHistory } from 'react-router';

export default function SignUpLoginTab() {
    const history = useHistory();

    const selectedTab = window.location.pathname.toLocaleLowerCase().indexOf('login') > -1 ? 'Login' : 'Sign Up';

    function onClick(tab: string) {
        if (tab === 'Login') {
            history.push('/login');
            return;
        }

        history.push('/signup');
    }

    const tabs = ['Login', 'Sign Up'];

    return (
        <Tabs tabs={tabs.map((t) => ({ key: t, label: t, value: t }))} activeTab={selectedTab} onTabChange={onClick} />
    );
}
